export const year = new Date().getFullYear();
